import { createSelector } from '@ngrx/store';
import { selectCountriesState } from '../../reducers';
import { CountriesState } from 'src/app/core/store/countries/countries.reducer';

/**
 * Get Countries List
 */
export const countriesList = createSelector(
  selectCountriesState,
  (state: CountriesState) => state.countriesList
);
